module.exports = __webpack_public_path__ + "img/developing-banner.a89ff761.png";